import BaseConfig from '../../common/config'

const Constantes = window.config.Constantes;

class PaywallConfig extends BaseConfig {
  constructor() {
    super();

    this.defaultModo = 'V';
    this.defaultModoRedirect = 'C';
    this.defaultCombo = '1';
    this.urlRedirect = Constantes.Dominios.login + "/suscripcion/C/";
    this.urlRedirectAccion = window.location.origin + "/suscripcion/A/";
    this.dominioIngresarDefault = Constantes.Dominios.login + "/ingresar/D/1/?callback=";
    this.dominioIngresar = Constantes.Dominios.login + "/ingresar/P/1/?callback=";
    this.urlAvatar = Constantes.Dominios.static + "/images/avatar/";
    this.urlEdicionImpresa = Constantes.Dominios.lanacion + "/edicion-impresa";

    this.SitioOrigen = Constantes.SitioOrigen;

    this.HotjarRecordingTrigger = Constantes.HotjarRecordingTrigger;

    this.HotjarHeatmapFormDocumento = Constantes.HotjarHeatmapFormDocumento;
    this.HotjarHeatmapFormPersonales = Constantes.HotjarHeatmapFormPersonales;
    this.HotjarHeatmapFormDomicilio = Constantes.HotjarHeatmapFormDomicilio;
    this.HotjarHeatmapFormPago = Constantes.HotjarHeatmapFormPago;
    this.HotjarHeatmapWall = Constantes.HotjarHeatmapWall;

    this.PRODUCTO_NOTA = parseInt(Constantes.PRODUCTO_NOTA); // 1;
    this.PRODUCTO_PDF = parseInt(Constantes.PRODUCTO_PDF); //2;
    this.SegmentoDefault = Constantes.SegmentoDefault;
    this.Segmento = Constantes.Segmento;

    this.ACCION_YA_TIENE_SUSCRIPCION = 1;

    this.Routes = Constantes.Routes;

    this.debugMode = false;
    this.debugFlowData = {
      "A": {
        codeResult: "04",
        message: ""
      },
      "B": {
        codeResult: "04",
        message: ""
      },
      "C": {
        codeResult: "04",
        message: ""
      },
      "D": {
        codeResult: "05",
        message: ""
      },
      "E": {
        codeResult: "01",
        message: ""
      },
      "F": {
        codeResult: "20",
        message: ""
      }
    }

    this.defaultUrl = window.location.origin + '/suscripcion/' + this.defaultModo + '/' + this.defaultSitioId + '/?';


    // ==================================================
    // Modos permitidos
    // al agrtegar una entrada en el route automaticamente la configura como modo permitido
    // ==================================================      
    this.Modos = [];
    for (var x in this.Routes) { this.Modos.push(this.Routes[x].modo); }


    // ==================================================
    // Campañas permitidas 
    // 373 : Campaña bonificada
    // 374 : Campaña paga
    // ==================================================  
    this.campaniaBonificada = Constantes.campaniaBonificada;
    this.campaniaPaga = Constantes.campaniaPaga;

    
  }

  // ==================================================
  // Valida si el modo en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  modoPermitido(modo) {
    if (this.Modos.indexOf(modo) == -1) return false;
    return true;
  }

  // ==================================================
  // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  sitioPermitido(sitio) {
    if (this.Sitios[sitio] == null) return false;
    return true;
  }
}

const Config = new PaywallConfig();

module.exports = {
  Config
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/config.js